import React from 'react';
import './glass.css';

/**
 * Floating action button (replaces @material-ui Fab + AddIcon). Fixed
 * bottom-right, sits above the chat widget. Teal gradient glass.
 */
const GlassFab = ({ onClick, icon = 'fas fa-plus', title = 'Add', label }) => (
  <button type="button" className="glass-fab" onClick={onClick} title={title} aria-label={title}>
    <i className={icon} />
    {label && <span className="glass-fab-label">{label}</span>}
  </button>
);

export default GlassFab;
